import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';

export const projectSensitivePropertyGroupsByNameSelector = (
  projectId: string
) =>
  createSelector(
    diagramSnapshotSelector(projectId),
    (diagram) => diagram?.model?.modelData?.sensitivePropertyGroupsByName || {}
  );
